
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { Prop, Watch } from "vue-property-decorator";

import { TracerStudy, TracerStudyQuestion } from "@/store/tracerstudy/types";
import { TracerStudyQuestionsModel } from "@/models/tracerstudy.model";

@Component({
  filters,
})
export default class ModalResponseIndividual extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetRespondentPerCandidate", {namespace: "tracerstudy"})
  public actionGetRespondentPerCandidate: any;

  /* STATE */
  @State("tracerStudy", {namespace: "tracerstudy"})
  public tracerStudy: TracerStudy;
  @State("tracer_study_questions", {namespace: "tracerstudy"})
  public tracer_study_questions: TracerStudyQuestionsModel[];
  @State("candidateAnswers", {namespace: "tracerstudy"})
  public candidateAnswers: any[];
  @State("detailCandidateAnswer", {namespace: "tracerstudy"})
  public detailCandidateAnswer: any;
  @State("respondentResult", {namespace: "tracerstudy"})
  public respondentResult: any;

  @Prop({default: false})
  public isShow: boolean;

  /* INITIALIZATION */
  public index: number = 1;

  public get isNext() {
    const {total_respondent_complete} = this.respondentResult;

    if (total_respondent_complete > this.index) {
      return true;
    }
    return false;
  }

  public get isPrevious() {
    if (this.index > 1) {
      return true;
    }
    return false;
  }


  public get answer(): any[] {
    let tmpAnswer: any[] = []
    this.tracer_study_questions.forEach((tracer, i) => {
      tmpAnswer[i] = this.getAnswer(tracer, tracer.choice)
    })
    return tmpAnswer
  }


  /* METHOD */
  public isCheckStatus(candidate: any) {
    if (candidate !== undefined) {
      return candidate.verification_status === 2;
    }
    return false;
  }

  public previous() {
    if (this.isPrevious) {
      this.index--;

      const {id} = this.tracerStudy;
      this.actionGetRespondentPerCandidate({
        params: {
          tracer_id: id,
          page: this.index,
        },
      });
    }
  }

  public next() {
    if (this.isNext) {
      this.index++;

      const {id} = this.tracerStudy;
      this.actionGetRespondentPerCandidate({
        params: {
          tracer_id: id,
          page: this.index,
        },
      });
    }
  }

  public getAnswer(question: TracerStudyQuestion, binding: any = null) {
    let answer: any = "";
    switch (question.answer_type) {
      case 0:
        answer = question.answer.answer_text;
        break;
      case 1:
        answer = question.answer.answer_text;
        break;
      case 2: {
        if (typeof question?.answer === 'object') {
          let index: boolean | number = false;
          (binding as any[]).filter((v, i) => {
            if (v.id === (question?.answer as any)?.choice_id) index = i
          })

          if (typeof index === 'number') answer = binding[index].choice_text
        }
        break;
      }
      case 3:
        break;
      case 4: {
        if (question?.answer instanceof Array) answer = question?.answer[0]?.answer_text
        break;
      }
      case 5:
        break;
      case 6: {
        if (question?.answer) {
          let result = (question?.answer as any)?.range_answer === binding
          console.log(`NO: ${question.index}. type 6: ${result}| ${(question?.answer as any)?.range_answer} | ${binding}`);
          answer = result
        } else {
          console.log("type 6: false");
          answer = false
        }
        break;
      }
      default:
        break;
    }

    return answer;
  }
}
